import { Alert } from '../types/alert'
import {
	BP_BY_MEASURE_TYPE,
	BpByMeasureTypeItem,
} from '../constants/clinicalBpPageConstants'
import { SYSTEM_BP_ICON_TYPES } from '../types/systemEvent'
import { getBloodPressureRange, getNameOrMail } from '../helpers'
import { useTimeController } from '@app/hooks/contexts/timeController/TimeControllerContext'

interface UseBpAlert {
	eventTypeBPData: BpByMeasureTypeItem | undefined
	iconType: SYSTEM_BP_ICON_TYPES
	eventTime: string
	name: string
}

export const useBpAlert = (alert: Alert): UseBpAlert => {
	const {
		formatters: { tdf3 },
	} = useTimeController()

	const bpAlertRange = getBloodPressureRange(
		alert.headers.last_bp_measure_systolic || null,
		alert.headers.last_bp_measure_diastolic || null
	)

	const mState =
		bpAlertRange.toUpperCase() as keyof typeof SYSTEM_BP_ICON_TYPES

	const eventTypeBPData = BP_BY_MEASURE_TYPE.find(
		item => item.id === bpAlertRange
	)

	const iconType = SYSTEM_BP_ICON_TYPES[mState]

	const eventTime = tdf3(alert.op?.addedTimestamp)

	const name = getNameOrMail(
		alert.patientData?.firstName || '',
		alert.patientData?.lastName || '',
		alert.patientData?.email
	)

	return {
		eventTypeBPData,
		iconType,
		eventTime,
		name,
	}
}
